import React from "react"
import WorldHeart from "../../static/icon-world-heart.svg"

const Marquee = props => {
  return (
    <div class="marquee">
      <div class="marquee__inner" aria-hidden="true">
        <span><WorldHeart /> Make a difference</span>
        <span><WorldHeart /> Make a difference</span>
        <span><WorldHeart /> Make a difference</span>
        <span><WorldHeart /> Make a difference</span>

      </div>
    </div>
  )
}

export default Marquee
